/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Thu Nov 21 2024
 **/

import { useShallow } from "zustand/react/shallow";
import usePersistStore from "./usePersistStore";

export function usePersistMydeskWidget() {
	const { isCustomBackground, mydeskWidgets } = usePersistStore(
		useShallow((state) => ({
			isCustomBackground: state.customBackground,
			mydeskWidgets: state.mydeskWidgets
		}))
	);
	const mydeskBackground = mydeskWidgets.background;

	return {
		mydeskWidgets,
		mydeskBackground,
		isCustomBackground
	};
}

export default usePersistMydeskWidget;
